<template>
	<div class="p_box">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>制作习题</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="p_flex p_m_t_180 p_f_r">
			<div class="select_box small_hand"  @click="goSingle(0)">
				<div class="select_img"><img src="../../../assets/img/da.png" /></div>
				<span class="type_size_22 p_flex p_f_c">制作答题卡</span>
			</div>
			<div class="select_box small_hand" @click="goSingle(1)">
				<div class="select_img"><img src="../../../assets/img/duo.png" /></div>
				<span class="type_size_22 p_flex p_f_c">多题制作</span>
			</div>
			<div class="select_box small_hand" @click="goSingle(2)">
				<div class="select_img"><img src="../../../assets/img/dan.png" /></div>
				<span class="type_size_22 p_flex p_f_c">单题制作</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Select',
	data() {
		return {
			selectList: [
				{
					name: '制作答题卡',
					img: '../../../assets/logo.png'
				},
				{
					name: '多题制作',
					img: '../../../assets/img/duo.png'
				},
				{
					name: '单题制作',
					img: '../../../assets/logo.png'
				}
			]
		};
	},
	methods: {
		goSingle(i) {
			if (i == 0) {
				this.$router.push({
					path: '/AnswerSheet',
				});
			} else if (i == 1) {
				this.$router.push({
					path: '/Single',
					query:{
						type : i
					}
				});
			} else {
				this.$router.push({
					path: '/Single',
					query:{
						type : i
					}
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.select_box {
	width: 270px;
	height: 400px;
	background: #ffffff;
	border-radius: 10px;
}

.select_img {
	width: 204px;
	height: 196px;
	margin: 50px auto;
}
img{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/make/select.vue